module.exports = __webpack_public_path__ + "static/media/internet_popup.18ac4c86.png";